import moment from 'moment-timezone';
import {  useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { PacmanLoader } from 'react-spinners';
import EventController from '../controllers/EventController';
import MemberController from '../controllers/MemberController';
import EventViewModel from '../models/events/GetEvents/EventViewModel';
import { MemberEventViewModel } from '../models/member/MemberEventViewModel';

export default function MembersEvents() {
    let { memberId } = useParams<{memberId: string}>();

    const [loading, setLoading] = useState(true);
    const [memberEvents, setMemberEvents] = useState<MemberEventViewModel[]>();
    const memberController = new MemberController();
    
    useEffect(() => {
        if (memberEvents == null) {
            getMemberEvents(memberId);
        }
    })

    const getMemberEvents = async (memberId: string) => {
        var result = await memberController.GetEventsForMember(memberId)
        if (result != null) {
            setMemberEvents(result);
        }
        setLoading(false);
    }

    if (loading) {
        return <div className="col-6 mx-auto text-center"><PacmanLoader color="#947a27" /></div>
    }

    return (
        <div className="col-12 mx-auto">
            <h1 className="text-center">Events</h1>
            <br />
            <table className="table table-dark">
                <thead>
                    <tr>
                        <th scope="col">Event Name</th>
                        <th scope="col">Event Hosts</th>
                        <th scope="col">Event Date</th>
                        <th scope="col">Entry Time</th>
                        <th scope="col">Exit Time</th>
                    </tr>
                </thead>
                <tbody>
                    {memberEvents && memberEvents.map((event, index) => {
                        return  <tr key={index.toString()} >
                                    <td scope="row" style={{ textAlign: "left" }}>{event.EventName}</td>
                                    <td style={{ textAlign: "left" }}>{event.EventHost}</td>
                                    <td style={{ textAlign: "left" }}>{moment.utc(event.EventDate).tz('Europe/London').format("ddd DD MMM yyyy")}</td>
                                    <td style={{ textAlign: "left" }}>{moment.utc(event.EntryTime).tz('Europe/London').format("HH:mm")}</td>
                                    <td style={{ textAlign: "left" }}>{moment.utc(event.DepartureTime).tz('Europe/London').format("HH:mm")}</td>
                                </tr>
                    })
                    }
                </tbody>
            </table>
        </div >
    );
}